import { useApiConfig } from '../useApiConfig';

import { ATLASSIAN_ME_KEY } from '../../utils/consts';
import { useQuery } from '@tanstack/react-query';
import { AtlassianApi } from 'osep-generator-service-client-v1';

export const useAtlassianMeQuery = () => {
  const { getApiConfig, axiosInstance } = useApiConfig();

  return useQuery({
    queryKey: [ATLASSIAN_ME_KEY],
    queryFn: async () => {
      try {
        const apiConfig = await getApiConfig();

        const atlassianApi = new AtlassianApi(
          apiConfig,
          undefined,
          axiosInstance,
        );

        const identity = await atlassianApi.getAtlassianIdentity();

        return { status: identity?.status, data: identity };
      } catch (error: any) {
        console.error('Error:', error);

        return { status: error?.response?.status, data: error?.response?.data };
      }
    },
  });
};
